<template>
  <div>
    <div class="status-box">
      <div class="img-box qr-box">
        <img src="../../assets/images/weixin-qr.png" alt="" />
        <p class="">请关注公众号，随时关注赛事进程</p>
      </div>
      <div class="team-button-box">
          <el-button class="pre" @click="next">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { apiSetProcess } from '../../plugins/apis';
export default { 
  data() {
    return {
      // cover_src:''
      processData:{

      }
    };
  }, 
  methods: {
    async next(){
      let r = await apiSetProcess(this.round.round_id,this.label,this.processData)
      if(r.code === 500){
        this.$message.error(r.message)
        return
      }
      this.$Bus.$emit('reload_NowProcess');
    }
  },
  mounted() {},
  computed:{
  },
  props:['message','award','round','label']
};
</script> 

<style>

</style>
